export default __webpack_public_path__ + "static/media/player-overlay.1dcc3b55.svg";